import React from 'react'
import "./color.css"

function GreenHC() {
    var x = localStorage.getItem("percentage hc")
    return (
        <div className = "green__background">
            {x == "NaN" ? "null": x} 
        </div>
    )
}

export default GreenHC